import styled from 'styled-components'

export const Logo = styled.img.attrs(props => ({
	src: props.src || '/images/logo/app/logo.svg'
}))`
	max-height: 1.3em;
	width: auto;
`